import { render, staticRenderFns } from "./login.vue?vue&type=template&id=aaf81612&scoped=true"
import script from "./login.vue?vue&type=script&lang=js"
export * from "./login.vue?vue&type=script&lang=js"
import style0 from "@/styles/roatestyle.css?vue&type=style&index=0&id=aaf81612&prod&scoped=true&lang=css&external"
import style1 from "./login.vue?vue&type=style&index=1&id=aaf81612&prod&scoped=true&lang=scss"
import style2 from "./login.vue?vue&type=style&index=2&id=aaf81612&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaf81612",
  null
  
)

export default component.exports